export default __webpack_public_path__ + "static/media/RuralAids.db5136df.png";